import { createContext, useContext, useEffect } from 'react';
import { getBrandConfig } from '@/brands';
import type { BrandConfig } from '@/brands/types';

const brandConfig = getBrandConfig(import.meta.env.VITE_BRAND);

const BrandContext = createContext<BrandConfig>(brandConfig);

type BrandProviderProps = {
  children: React.ReactNode;
};

export function BrandProvider({ children }: BrandProviderProps) {
  useEffect(() => {
    document.title = brandConfig.appTitle;

    const faviconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (faviconLink) {
      faviconLink.href = `/${brandConfig.assets.favicon}`;
    }
  }, []);

  return (
    <BrandContext.Provider value={brandConfig}>
      {children}
    </BrandContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const useBrand = () => {
  return useContext(BrandContext);
};
